export default __webpack_public_path__ + "static/media/longCloud19.7f9ddf49.webp";